export default "__VITE_ASSET__1a6ade8f__"